import { render, staticRenderFns } from "./caseShow_mobile.vue?vue&type=template&id=7dbf33cb&scoped=true&"
import script from "./caseShow_mobile.vue?vue&type=script&lang=js&"
export * from "./caseShow_mobile.vue?vue&type=script&lang=js&"
import style0 from "./caseShow_mobile.vue?vue&type=style&index=0&id=7dbf33cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbf33cb",
  null
  
)

export default component.exports